import { Stack } from "@mui/material"

import FilterSideBar from "./Filters"
import Header from "./Header"
import ItemList from "./ItemList"

export default function ItemsSection() {
  return (
    <>
      <Header />
      <Stack direction="row">
        <FilterSideBar />
        <ItemList />
      </Stack>
    </>
  )
}
